import { LensTheme } from '@diligentcorp/atlas-theme-mui-lens';
import InfoIcon from '@mui/icons-material/Info';
import { Box, Chip, Tooltip, Typography, useTheme } from '@mui/material';
import { InviteUserDropdownOption } from '../../DropdownSelect';

export const UserChips = ({
  selectedSuperAdmins,
  selectedApprovers,
  handleDeleteUserChip,
}: {
  selectedSuperAdmins: InviteUserDropdownOption[];
  selectedApprovers: InviteUserDropdownOption[];
  handleDeleteUserChip: (member: InviteUserDropdownOption) => void;
}) => {
  const { tokens } = useTheme<LensTheme>();
  const sp = tokens.semantic.spacing.desktop.gap;

  return (
    <>
      {selectedSuperAdmins.length > 0 && (
        <Box
          sx={{ display: 'flex', flexDirection: 'column', gap: sp[1].value }}
        >
          <Typography
            variant="h6"
            component="h2"
            sx={{
              fontWeight: 600,
              display: 'flex',
              alignItems: 'center',
              gap: sp[1].value,
            }}
          >
            Selected super admins
            <Tooltip title="These users have full access automatically. Please bear this in mind when adding members to your team">
              <InfoIcon />
            </Tooltip>
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: sp[1].value }}>
            {selectedSuperAdmins.map((admin) => {
              return (
                <Chip
                  key={admin.value}
                  label={admin.label}
                  variant="outlined"
                  onDelete={() => handleDeleteUserChip(admin)}
                />
              );
            })}
          </Box>
        </Box>
      )}
      {selectedApprovers.length > 0 && (
        <Box
          sx={{ display: 'flex', flexDirection: 'column', gap: sp[1].value }}
        >
          <Typography variant="h6" component="h2" sx={{ fontWeight: 600 }}>
            Selected approvers
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: sp[1].value }}>
            {selectedApprovers.map((approver) => {
              return (
                <Chip
                  key={approver.value}
                  label={approver.label}
                  variant="outlined"
                  onDelete={() => handleDeleteUserChip(approver)}
                />
              );
            })}
          </Box>
        </Box>
      )}
    </>
  );
};
